<template>
	<div class="houselist">
		<div class="houselist-title">
			请填写要置顶的房源编号
		</div>
		<div class="field">
			<van-field placeholder="请填写房源编号" v-model="id"></van-field>
		</div>
		<div class="lists-title">
			<div>选择类型</div>
			<div :class="{active:active==0}" @click="()=>{active=0}">租房</div>
			<div :class="{active:active==1}" @click="()=>{active=1}">二手房</div>
			<div :class="{active:active==2}" @click="()=>{active=2}">商铺</div>
		</div>
		<div class="btn" @click="findHouse">查询房源</div>
		<div class="getNUm" @click="preview">如何获取编号？点击查看</div>
 
	</div>
</template>

<script>
	var root = process.env.VUE_APP_API_URL;
	import {
		Toast,
		Button,
		Icon,
		Row,
		Col,
		Field,
		Tag,
		Dialog,
		ImagePreview
	} from "vant";

	export default {
		components: {
			[Dialog.name]: Dialog,
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Field.name]: Field,
			[Row.name]: Row,
			[Col.name]: Col,
			[ImagePreview.Component.name]: ImagePreview.Component,
			[Tag.name]: Tag
		},

		data() {
			return {
				id: '',
				isSearch: false,
				active: -1,
				zufangs: [],
				ershoufangs: [],
				shops: []
			};
		},
		mounted() {

		},
		methods: {
			findHouse() {
				this.isSearch = true
				if (this.id == '' || this.active==-1) {
					this.$dialog.alert({
						title: "提示",
						message: "请选择房源类型"
					})
					return
				}
				$.ajax({
					url: root + 'delete/find',
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						id: this.id, 
						type: this.active
					},
					headers: this.getRequestHeader(),
					success: (reponseData, status) => {
						if(!reponseData.data){
							this.$dialog.alert({
								title: "提示",
								message: "没有查找到房源信息"
							})
						}else{
							let url = ''
							if(this.active==0){
								url = 'zufang'
							}
							if(this.active==1){
								url = 'ershoufang'
							}
							if(this.active==2){
								url = 'shop'
							}
							this.$router.push('/user/sticky/'+reponseData.data.id+'/'+url)
						}
					},
					error: () => {

					},
				});
			},
			preview() {
				ImagePreview({
					closeable: true,
					images: [require("../../assets/images/bianhao.png")]
				})
			},
			del(item, type) {
				this.$dialog
					.confirm({
						title: "删除提示",
						message: "确定删除这个房源吗？删除后不可恢复了额",
						confirmButtonText: "我要删除",
						cancelButtonText: "不删除",
						confirmButtonColor: "#ee0a24"
					})
					.then(() => {
						$.ajax({
							url: root + 'delete/find',
							timeout: 120000,
							dataType: "json",
							type: "get",
							data: {
								id: item.id,
								type: type
							},
							headers: this.getRequestHeader(),
							success: (reponseData, status) => {
								this.$dialog.alert({
									title: "提示",
									message: reponseData.message
								})
								this.findHouse()
							},
							error: () => {
								self.$toast("system error");
							}
						});
					})
					.catch(() => {
						// on cancel
					});
			}
		}
	};
</script>

<style scoped>
	.houselist {
		padding: 15px;
	}

	.houselist-title {
		margin-bottom: 10px;
	}

	.houselist .field {
		border: #eee 1px solid;
		border-radius: 8px;
		overflow: hidden;
		margin-bottom: 15px;
	}

	.houselist .btn {
		background-image: linear-gradient(90deg, #ef8732, #f56229);
		color: #fff;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 45px;
	}

	.lists-title {
		text-align: center;
		margin: 15px 0;
		color: #333;
		display: flex;
		align-items: center; 
	}

	.lists-title div { 
		background-color: rgba(0, 0, 0, 0.03);
		color: #555;
		font-size: 14px;
		border-radius: 4px;
		width: 70px;
		height: 24px;
		display: flex;
		align-items: center; 
		justify-content: center;
		margin-right: 10px;
	}

	.lists-title div.active {
		color: #fff;
		background-color: rgba(245, 98, 41, 0.7);
	}

	.lists .item {
		display: flex;
		background-color: #f5f5f5;
		padding: 10px;
		border-radius: 4px;
		margin-top: 15px;
		color: #333;
	}

	.lists .item .info {
		flex: 1;
		color: #333;
		font-size: 14px;
		line-height: 1.5;
		display: flex;
		flex-direction: column;
	}

	.lists .item .info .community {
		font-weight: bold;
		font-size: 16px;
		margin-bottom: 4px;
	}

	.lists .item .del {
		background-image: linear-gradient(90deg, #ef8732, #f56229);
		color: #fff;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 60px;
		font-size: 14px;
		height: 24px;
		margin-left: auto;
		margin-top: auto;
	}

	.lists .thumb {
		width: 100px;
		height: 100px;
		margin-right: 10px;
		border-radius: 4px;
	}

	.getNUm {
		text-align: center;
		font-size: 12px;
		margin-top: 10px;
		color: #999;
	}
</style>